import React from "react";

import { useTranslation } from "react-i18next";

import InfoTooltip from "../../utils/InfoTooltip";

import type { JSX } from "react";

import type { StorefrontProjectParams } from "../../../api/ProjectAPI.types";

interface SessionsMaxConfigurationProps {
  sessionsMax: number;
  onChange: <K extends keyof StorefrontProjectParams>(
    key: K,
    value: StorefrontProjectParams[K],
  ) => void;
}

function SessionsMaxConfiguration({
  sessionsMax,
  onChange,
}: SessionsMaxConfigurationProps): JSX.Element {
  const { t } = useTranslation("editor-platform");

  return (
    <div className="editor-form-section section-separator">
      <div className="editor-form-section-title">
        {t("sessionsMaxSettings")}
      </div>
      <div className="editor-form-row editor-form-row-inline">
        <div className="editor-form-input editor-form-input-box-h">
          <input
            className="editor-form-input-title w-18"
            max={5}
            min={1}
            type="number"
            value={sessionsMax || 3}
            onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
              onChange("sessions_max", Number(e.target.value));
            }}
          />
        </div>
        <div className="editor-form-label">{t("sessionsMax")}</div>
        <InfoTooltip width="500px">{t("sessionsMaxTooltip")}</InfoTooltip>
      </div>
    </div>
  );
}

export default SessionsMaxConfiguration;
